export const css = {
    card: 'LJsJBhC-',
    leading: 'acLXPO5q',
    trailing: 'd-arBBdz',
    basefont: 'tcK8yuLC',
    titlefont: 'kzLk7MvC',
    alphaHalfBlack: 'sHjUmLl-',
    actions: 'vgdArewN',
    root: 'QfeOeECQ',
    legend: 'fsmZUVjx',
    legendItem: 'n2r1Ift5',
    content: 'QwONLJIg',
    cards: 'OjJLNvLh',
    cardContainer: 'ArS7Gtpe',
    expanded: '_95aw1rRU',
    ' _key': 'mc-widgets/study'
};
export default css;
